import { API } from "config/api";
import { IAlertRequestBody, IAlertResponseData } from "./types";

export const getAlertListApi = async (body: IAlertRequestBody) => {
  const { data } = await API.post<IAlertResponseData>("/call/get", body);
  return data.data;
};
